import React from 'react';

import { default as RheBodyText } from '@RHEnvironmental/pattern-library/dist/js/components/BodyText';
import { getClassNames } from '@RHEnvironmental/pattern-library/dist/js/services/stylingUtils';

const BodyText = ({ children, className = undefined }) => {
    const classNames = getClassNames(className, { 'body-text': true });

    return (
        <RheBodyText className={classNames}>
            <p>{children}</p>
        </RheBodyText>
    );
};

export default BodyText;
